;
define("product_views_option_password.tpl", function(){});

